module.exports = __webpack_public_path__ + "images/be1f7b4.webp";